import { EnvironmentName } from '@shared/enum';
import { SubFeatureTogglingRecord } from './feature-toggling.type';
import { Feature } from './feature.enum';

export const isFeatureEnabled = (
  features: SubFeatureTogglingRecord,
  feature: string | Feature,
  environmentName: EnvironmentName
): boolean => features[feature]?.[environmentName] ?? true;
